import React, { useState } from "react";
import styled from "styled-components";
import Modal from "../../../../../components/modal";
import { Toggle } from "../../inspect/components/edit-account/components/toggle";
import Icon from "@material-ui/core/Icon";
import helpTip from "../../../../../images/change-goal-pictures/helpTip.png";
import IconPause from "../../../../../images/new-vacation-mode/icon-small-pause.svg";
import IconPracticeMode from "../../../../../images/new-vacation-mode/icon-small-practice.svg";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
`;

const ModeSelector = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

const ModeOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border: 2px solid ${(props) => (props.selected ? "#05d141" : "#e0e0e0")};
  border-radius: 8px;
  cursor: pointer;
  background: ${(props) => (props.selected ? "#f0fff0" : "#fff")};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.selected ? "#05d141" : "#b0b0b0")};
  }

  img {
    width: 42px;
    height: 42px;
  }

  span {
    font-weight: 600;
    color: ${(props) => (props.selected ? "#05d141" : "#333")};
  }
`;

const VacationOff = styled.div`
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    font-size: 24px;
    color: #999;
  }
`

const SectionTitle = styled.h4`
  margin: 0;
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
`;

const InfoText = styled.p`
  margin: 8px 0 16px 0;
  color: #444;
  font-size: 0.9rem;
  line-height: 1.4;
`;

const InfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
`;

const HideTargetText = styled.span`
  margin: 0;
  font-weight: bold;
  color: #333;
  font-size: 1rem;

  @media (max-width: 900px) {
    font-size: .9rem !important;
  }
`;

export const BulkEditVacation = (props) => {
  const [vacationMode, setVacationMode] = useState(0);
  const [vacationModeInfo, setVacationModeInfo] = useState({
    practice_mode: false,
    log_weekly_body_metrics: false,
    hide_protein: false,
    hide_carbs: false,
    hide_fat: false,
  });
  const [showHideTargetModal, setShowHideTargetModal] = useState(false);
  const [showLogWeeklyBodyMetricsModal, setShowLogWeeklyBodyMetricsModal] =
    useState(false);

  const handleToggle = (preferenceKey) => {
    setVacationModeInfo((prev) => ({
      ...prev,
      [preferenceKey]: !prev[preferenceKey],
    }));
  };

  const handleModeSelect = (mode) => {
    if (mode === "pause") {
      setVacationMode(1);
      setVacationModeInfo((prev) => ({
        ...prev,
        practice_mode: false,
      }));
    } else if (mode === "practice") {
      setVacationMode(1);
      setVacationModeInfo((prev) => ({
        ...prev,
        practice_mode: true,
      }));
    } else {
      setVacationMode(0);
      setVacationModeInfo({
        practice_mode: false,
        log_weekly_body_metrics: false,
        hide_protein: false,
        hide_carbs: false,
        hide_fat: false,
      });
    }
  };

  const handleSubmit = () => {
    if (vacationMode === 0) {
      props.handleSubmit({
        vacation_mode: 0,
        vacation_mode_info: {
          practice_mode: false,
          log_weekly_body_metrics: false,
          hide_protein: false,
          hide_carbs: false,
          hide_fat: false,
        },
      });
    } else {
      props.handleSubmit({
        vacation_mode: vacationMode,
        vacation_mode_info: vacationModeInfo,
      });
    }
  };

  const isPauseMode = vacationMode === 1 && !vacationModeInfo.practice_mode;
  const isPracticeMode = vacationMode === 1 && vacationModeInfo.practice_mode;

  return (
    <>
      <Modal
        title="Bulk edit pause/practice mode"
        submitLabel="Confirm"
        open={props.open}
        onClose={props.onClose}
        handleSubmit={handleSubmit}
      >
        <Container>
          <div>
            <SectionTitle>Select Mode</SectionTitle>
            <InfoText>
              Choose whether to pause goals or enable practice mode for selected
              clients
            </InfoText>
            <ModeSelector>
              <ModeOption
                selected={vacationMode === 0}
                onClick={() => handleModeSelect("off")}
              >
                <VacationOff>
                  <span>×</span>
                </VacationOff>
                <span>Turn Off</span>
              </ModeOption>
              <ModeOption
                selected={isPauseMode}
                onClick={() => handleModeSelect("pause")}
              >
                <img src={IconPause} alt="Pause mode" />
                <span>Pause Goal</span>
              </ModeOption>
              <ModeOption
                selected={isPracticeMode}
                onClick={() => handleModeSelect("practice")}
              >
                <img src={IconPracticeMode} alt="Practice mode" />
                <span>Practice Mode</span>
              </ModeOption>
            </ModeSelector>
          </div>
          {vacationMode === 0 && (
            <div>
              <SectionTitle>Description</SectionTitle>
              <InfoText>
                When turning off Pause Goal or Practice Mode, clients will recieve a message in the app to confirm this setting change. Some clients may be prompted to enter a starting weight.
              </InfoText>
            </div>
          )}
          {vacationMode !== 0 && (
            <>
              <div>
                <SectionTitle>Description</SectionTitle>
                {isPauseMode ? (
                  <InfoText>
                    Disable check-ins and adjustments whenever clients are not
                    actively pursuing their goal or can't focus on hitting their
                    macros–whether they're on vacation, sick, or just want to
                    log food without aiming for a specific goal.
                  </InfoText>
                ) : (
                  <InfoText>
                    Turn off check-ins and adjustments to practice logging food
                    without the pressure to hit macros. This can be helpful when
                    clients are new to the app and first learning how to track
                    macros.
                  </InfoText>
                )}
              </div>

              <div>
                <SectionTitle>Customize Experience</SectionTitle>
                <Toggle
                  info={true}
                  onInfoClick={() => setShowLogWeeklyBodyMetricsModal(true)}
                  label="Log weekly body metrics"
                  checked={vacationModeInfo.log_weekly_body_metrics}
                  onChange={() => handleToggle("log_weekly_body_metrics")}
                  value="logWeeklyBodyMetrics"
                />
                <InfoText>
                  Turn on weekly prompts to log weight and body fat. Adherence
                  to macro targets won't be considered and no adjustments will
                  be made.
                </InfoText>
                <InfoSection>
                  <Icon
                    onClick={() => setShowHideTargetModal(true)}
                    style={{ cursor: "pointer" }}
                  >
                    help_outline
                  </Icon>
                  <HideTargetText>Hide macro targets</HideTargetText>
                </InfoSection>
                <InfoText>Track food without aiming for macro targets</InfoText>

                <Toggle
                  label="Hide Protein"
                  checked={vacationModeInfo.hide_protein}
                  onChange={() => handleToggle("hide_protein")}
                  value="hideProtein"
                />
                <Toggle
                  label="Hide Carbs"
                  checked={vacationModeInfo.hide_carbs}
                  onChange={() => handleToggle("hide_carbs")}
                  value="hideCarbs"
                />
                <Toggle
                  label="Hide Fat"
                  checked={vacationModeInfo.hide_fat}
                  onChange={() => handleToggle("hide_fat")}
                  value="hideFat"
                />
              </div>
            </>
          )}
        </Container>
      </Modal>

      <Dialog
        open={showHideTargetModal}
        onClose={() => setShowHideTargetModal(false)}
      >
        <DialogContent className="avn-modal-content-container">
          <img src={helpTip} alt="coaching-icon" />
          <h4>Why hide your macro targets?</h4>
          <p style={{ textAlign: "center", fontWeight: "bold" }}>
            Popular reasons
          </p>
          <ul>
            {isPauseMode ? (
              <>
                <li>You want to log food without the pressure to hit your macros.</li>
                <li>You'd rather focus on food choices than hitting specific targets.</li>
                <li>You only care about hitting certain macros.</li>
              </>
            ) : (
              <>
                <li>You want to practice logging food without the pressure to hit your macros.</li>
                <li>You want to focus on food choices while building tracking skills gradually.</li>
                <li>You want to see how much you normally eat without being influenced by your targets.</li>
                <li>You only want to aim for certain macros while you get the hang of using the system.</li>
              </>
            )}
          </ul>
          <DialogActions className="avn-modal-actions-container">
            <button
              className="avn-modal-action"
              onClick={() => setShowHideTargetModal(false)}
            >
              Ok got it
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        open={showLogWeeklyBodyMetricsModal}
        onClose={() => setShowLogWeeklyBodyMetricsModal(false)}
      >
        <DialogContent className="avn-modal-content-container">
          <img src={helpTip} alt="coaching-icon" />
          <h4>Why log weekly body metrics?</h4>
          <p style={{ maxWidth: "510px" }}>
            {isPauseMode ? (
              "You'll turn these prompts on when you want to continue tracking body changes while your goal is paused. These aren't check-ins–so you don't need to hit your macros and you won't receive adjustments–but you will be able to record your weight, body fat, body measurements, and progress photos each week."
            ) : (
              "You'll turn these prompts on when you want to continue tracking body changes while on Practice Mode. These aren't check-ins–so you don't need to hit your macros and you won't receive adjustments–but you will be able to record your weight, body fat, body measurements, and progress photos each week."
            )}
          </p>
          <DialogActions className="avn-modal-actions-container">
            <button
              className="avn-modal-action"
              onClick={() => setShowLogWeeklyBodyMetricsModal(false)}
            >
              Ok got it
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
